import {
  CardContents,
  CardFooter,
  useMediaQuery,
  useTheme,
} from '@sparemin/blockhead';
import React from 'react';
import { useAuth } from 'ui/context';
import AuthCardHeader from './AuthCardHeader';
import * as S from './styles';
import { AuthCardProps } from './types';

/**
 * Provides basic styling for the `Card` component used for all of the
 * authentication cards.
 *
 * Just like `Card` from `@sparemin/blockhead`, this component makes available
 * a few subcomponents.  The subcomponents available from `AuthCard` should be
 * used with `AuthCard` as they might override the subcomponents that are
 * exported with `Card`.
 *
 * The following subcomponents are available:
 * <ul>
 *  <li>`AuthCard.Contents` - wraps children of `AuthCard`</li>
 *  <li>`AuthCard.Header` - wraps `AuthCard` header</li>
 *  <li>`AuthCard.Footer` - wraps `AuthCard` footer</li>
 * <ul>
 */
function AuthCard(props: AuthCardProps): React.ReactElement | null {
  const { breakpoints } = useTheme();
  const isMobile = useMediaQuery(breakpoints.down('md'));
  const { navigationType } = useAuth();

  return (
    <S.Root fullScreen={navigationType === 'modal' && isMobile} {...props} />
  );
}

AuthCard.Contents = CardContents;
AuthCard.Header = AuthCardHeader;
AuthCard.Footer = CardFooter;

export default AuthCard;
